<div class="p-3">


  <header class="fs-4 fw-bold ms-2 pt-2 hex-65-grey mb-3">Search</header>
  <form class="mb-4 ms-2" role="search" (submit)="search()">
    <div class="col-md-6 col-lg-5 col-sm-12 d-flex gap-2">
      <input [(ngModel)]="term" name="searchTerm" class="form-control" type="text" id="search_input"
        placeholder="Type and click on search" autocomplete="off" />
        <button type="submit" class="btn btn-primary" id="search_btn">Search</button>
        <button type="button" class="btn btn-primary" (click)="location.back()">Back</button>
      </div>


    </form>

    <ng-container>

      <div class="d-flex flex-wrap align-items-center gap-2 ps-2 pb-3">
        <label class="me-2 fw-semibold mb-0">Display Results for:</label>

        @if (!searchBySalesAgent) {
          <label class="filter-chip" tappable [ngClass]="{'active-card':show.doctor}">
            <input type="checkbox" class="d-none" name="doctor" [(ngModel)]="show.doctor">Business
          </label>
          <!-- <label class="filter-chip" tappable [ngClass]="{'active-card':show.partner}">
          <input type="checkbox" class="d-none" name="partner" [(ngModel)]="show.partner">Partner
        </label> -->
        <label class="filter-chip" tappable [ngClass]="{'active-card':show.patient}">
          <input type="checkbox" class="d-none" name="patient" [(ngModel)]="show.patient">Customer
        </label>
        <label class="filter-chip" tappable [ngClass]="{'active-card':show.contract}">
          <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.contract">Contract
        </label>
        <!-- <label class="filter-chip" tappable [ngClass]="{'active-card':show.payments}">
        <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.payments">Payment Processing
      </label> -->
      <label class="filter-chip" tappable [ngClass]="{'active-card':show.ar}">
        <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.ar">Debt Recovery
      </label>
      <label class="filter-chip" tappable [ngClass]="{'active-card':show.proposal}">
        <input type="checkbox" class="d-none" name="contract" [(ngModel)]="show.proposal">Proposal Request
      </label>
      <label class="filter-chip" tappable [ngClass]="{'active-card':show.training}">
        <input type="checkbox" class="d-none" name="training" [(ngModel)]="show.training">Trainings
      </label>
    }

    @if (searchBySalesAgent || isManager) {
      <label class="filter-chip" tappable [ngClass]="{'active-card':show.leads}">
        <input type="checkbox" class="d-none" name="leads" [(ngModel)]="show.leads">Leads
      </label>
    }

  </div>

  @if (!emptyData && show && !show.doctor && !show.partner && !show.patient && !show.contract && !show.payments && !show.ar && !show.proposal && !show.training && !show.leads) {
    <div class="alert alert-warning mx-2"
      >
      Please select at least one filter to see results.
    </div>
  }


  @if (emptyData) {
    <div class="card card-default mx-2">
      <div class="card-header">Search - "{{term?term:''}}"</div>
      <div class="card-body">
        <p class="text-center mb-0">No Result Found!</p>
      </div>
    </div>
  }

  <div class="row g-3">
    @if (!searchBySalesAgent) {
      @if ((show && show.doctor) && (results && results.doctors && results.doctors.length)) {
        <div class="col-lg-6 col-sm-12"
          >
          <div class="card card-default h-100 p-3">
            <h3 class="fs-5 fw-bold hex-65-grey mb-3">Businesses</h3>
            <div class="d-flex flex-column gap-3">
              @for (doctor of results.doctors; track doctor) {
                <div
                  [routerLink]="'/app/business/details/'+doctor.doctor_id">
                  <div class="p-3 border rounded clickable-item">
                    <h3 class="fs-6 fw-bold text-green mb-2">
                      {{doctor.doctor_name ? doctor.doctor_name : 'N/A'}}
                    </h3>
                    <div class="row g-2">
                      <div class="col-md-6 text-label">
                        <span class="text-muted">Email:</span>
                        <span [innerHTML]="doctor.doctor_email | highlight:searched_string"></span>
                      </div>
                      <div class="col-md-6 text-label"><span class="text-muted">Phone:</span>
                    {{doctor.doctor_mobile}}</div>
                    <div class="col-md-6 text-label">
                      <span class="text-muted">Business Name:</span>
                      <span [innerHTML]="doctor.practice_name | highlight:searched_string"></span>
                    </div>
                    <div class="col-md-6 text-label">
                      <span class="text-muted">Business Email:</span>
                      <span [innerHTML]="doctor.practice_email | highlight:searched_string"></span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="text-end mt-2">
            <a (click)="viewAllDetails('doctor')"><small>View All ({{totalRowsOfEach?.doctor_list}})</small></a>
          </div>
        </div>
      </div>
    }
    @if ((show && show.contract) && (results && results.contracts && results.contracts.length)) {
      <div class="col-lg-6 col-sm-12"
        >
        <div class="card card-default h-100 p-3">
          <h3 class="fs-5 fw-bold hex-65-grey mb-3">Contracts</h3>
          <div class="d-flex flex-column gap-3">
            @for (contract of results.contracts; track contract) {
              <div
                [routerLink]="'/app/contracts/details/'+contract.contract_id" id="contract_details">
                <div class="p-3 border rounded clickable-item">
                  <h3 class="fs-6 fw-bold text-green mb-2 d-flex align-items-center gap-2 flex-wrap">
                    <span [innerHTML]="contract.contract_code | highlight:searched_string"></span>
                    @if (contract.pf_status<3) {
                      <span class="badge bg-primary">Active</span>
                    }
                    @if (contract.pf_status==3) {
                      <span class="badge bg-warning">Overdue</span>
                    }
                    @if (contract.pf_status==4) {
                      <span class="badge bg-success">Completed</span>
                    }
                    @if (contract.pf_status==5) {
                      <span class="badge bg-danger">Canceled</span>
                    }
                  </h3>
                  <div class="row g-2">
                    <div class="col-md-6 text-label"><span class="text-muted">Business Owner Name:</span>
                    {{contract.doctor_title}} <span
                  [innerHTML]="contract.doctor_name | highlight:searched_string:'capital'"></span>
                </div>
                <div class="col-md-6 text-label"><span class="text-muted">Business Owner Email:</span>
                <span [innerHTML]="contract.doctor_email | highlight:searched_string"></span>
              </div>
              <div class="col-md-6 text-label"><span class="text-muted">Customer Name:</span>
              <span [innerHTML]="contract.patient_name | highlight:searched_string:'capital'"></span>
            </div>
            <div class="col-md-6 text-label"><span class="text-muted">Customer Email:</span>
            <span [innerHTML]="contract.patient_email | highlight:searched_string"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div class="text-end mt-2">
  <a (click)="viewAllDetails('contract')"><small>View All ({{totalRowsOfEach?.pf_payments}})</small></a>
</div>
</div>
</div>
}
@if ((show && show.partner) &&(results && results.partners && results.partners.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    <div class="card card-default h-100 p-3">
      <h3 class="fs-5 fw-bold hex-65-grey mb-3">Partners</h3>
      <div class="d-flex flex-column gap-3">
        @for (partner of results.partners; track partner) {
          <div
            (click)="viewPartner(partner.partner_id)">
            <div class="p-3 border rounded clickable-item">
              <h3 class="fs-6 fw-bold text-green mb-2">{{partner.title}}
                <span [innerHTML]="partner.partner_name | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row g-2">
                <div class="col-md-6 text-label"><span class="text-muted">Email:</span>
                <span [innerHTML]="partner.partner_email | highlight:searched_string"></span>
              </div>
              <div class="col-md-6 text-label"><span class="text-muted">Phone:</span>
            {{partner.partner_mobile}}</div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="text-end mt-2">
    <a (click)="viewAllDetails('partner')"><small>View All ({{totalRowsOfEach?.partner_list}})</small></a>
  </div>
</div>
</div>
}
@if ((show && show.patient) &&(results && results.patients && results.patients.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    <div class="card card-default h-100 p-3">
      <h3 class="fs-5 fw-bold hex-65-grey mb-3">Customers</h3>
      <div class="d-flex flex-column gap-3">
        @for (patient of results.patients; track patient) {
          <div
            [routerLink]="'/app/customers/profile/'+patient.patient_id">
            <div class="p-3 border rounded clickable-item">
              <h3 class="fs-6 fw-bold text-green mb-2">{{patient.patient_title}}
                <span [innerHTML]="patient.patient_name | highlight:searched_string:'capital'"></span>
              </h3>
              <div class="row g-2">
                <div class="col-md-6 text-label"><span class="text-muted">Email:</span>
                <span [innerHTML]="patient.patient_email | highlight:searched_string"></span>
              </div>
              <div class="col-md-6 text-label"><span class="text-muted">Phone:</span>
            {{patient.patient_mobile}}</div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="text-end mt-2">
    <a (click)="viewAllDetails('patient')"><small>View All ({{totalRowsOfEach?.patient_list}})</small></a>
  </div>
</div>
</div>
}
@if ((show && show.payments) &&(results && results.payments && results.payments.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    <div class="card card-default h-100 p-3">
      <h3 class="fs-5 fw-bold hex-65-grey mb-3">Payments Processed</h3>
      <div class="d-flex flex-column gap-3">
        @for (payment of results.payments; track payment) {
          <div
            [routerLink]="'/app/payment-processing/'+payment.id">
            <div class="p-3 border rounded clickable-item">
              <h3 class="fs-6 fw-bold text-green mb-2 d-flex align-items-center gap-2 flex-wrap">
                <span [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
                @if (payment.status==1) {
                  <span class="badge bg-warning">Pending</span>
                }
                @if (payment.status==2) {
                  <span class="badge bg-success">Success</span>
                }
                @if (payment.status==3) {
                  <span class="badge bg-danger">Failed</span>
                }
                @if (payment.status==4) {
                  <span class="badge bg-info">Refunded</span>
                }
                @if (payment.status==5) {
                  <span class="badge bg-danger">Declined</span>
                }
              </h3>
              <div class="row g-2">
                <div class="col-md-6 text-label">
                  <span class="text-muted">Email:</span>
                  <span [innerHTML]="payment.patient_email | highlight:searched_string"></span>
                </div>
                <div class="col-md-6 text-label">
                  <span class="text-muted">Phone:</span>
                  {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}
                </div>
                <div class="col-12 text-label">
                  <span class="text-muted">Payment ID:</span>
                  @if (payment.payment_process_code) {
                    <span
                    [innerHTML]="payment.payment_process_code | highlight:searched_string"></span>
                  }
                  @if (!payment.payment_process_code) {
                    <span>N/A</span>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="text-end mt-2">
        <a (click)="viewAllDetails('payments')"><small>View All ({{totalRowsOfEach?.payments_list}})</small></a>
      </div>
    </div>
  </div>
}
@if ((show && show.ar) &&(results && results.ar && results.ar.length)) {
  <div class="col-lg-6 col-sm-12">
    @if (results.ar; as proposal_ar) {
      <ng-container
      *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal_ar, heading: 'Debt Recovery', link: '/app/debt-recovery/details/',count:$safeNavigationMigration(totalRowsOfEach?.ar_list),search_type:'ar'}}"></ng-container>
    }
  </div>
}
@if ((show && show.proposal) &&(results && results.proposal && results.proposal.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    @if (results.proposal; as proposal) {
      <ng-container
      *ngTemplateOutlet="proposals_listing; context: {data: {list: proposal, heading: 'Proposal Request', link: '/app/proposal/details/',count:$safeNavigationMigration(totalRowsOfEach?.proposal_list),search_type:'proposal'}}"></ng-container>
    }
  </div>
}
@if ((show && show.pa_leads) &&(results && results.pa_leads && results.pa_leads.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    <div class="card card-default h-100 p-3">
      <h3 class="fs-5 fw-bold hex-65-grey mb-3">Pre-approval Leads</h3>
      <div class="d-flex flex-column gap-3">
        @for (lead of results.pa_leads; track lead) {
          <div
            [routerLink]="'/app/patients/customers-leads/details/'+lead.application_id">
            <div class="p-3 border rounded clickable-item">
              <h3 class="fs-6 fw-bold text-green mb-2">
                <span [innerHTML]="lead.application_id | highlight:searched_string"></span>
              </h3>
              <div class="row g-2">
                <div class="col-md-6 text-label"><span class="text-muted">Business Owner Name:</span>
                <span
                [innerHTML]="(lead.doctor_first_name + lead.doctor_last_name) | highlight:searched_string"></span>
              </div>
              <div class="col-md-6 text-label"><span class="text-muted">Business Owner Email:</span>
              <span [innerHTML]="lead.doctor_email | highlight:searched_string"></span>
            </div>
            <div class="col-md-6 text-label"><span class="text-muted">Customer Name:</span>
            <span [innerHTML]="lead.full_cust_name | highlight:searched_string"></span>
          </div>
          <div class="col-md-6 text-label"><span class="text-muted">Customer Email:</span>
          <span [innerHTML]="lead.customer_email | highlight:searched_string"></span>
        </div>
      </div>
    </div>
  </div>
}
</div>
<div class="text-end mt-2">
  <a (click)="viewAllDetails('pa_leads')"><small>View All ({{totalRowsOfEach?.pa_leads}})</small></a>
</div>
</div>
</div>
}
@if ((show && show.training) && (results && results.training && results.training.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    <div class="card card-default h-100 p-3">
      <h3 class="fs-5 fw-bold hex-65-grey mb-3">Trainings</h3>
      <div class="d-flex flex-column gap-3">
        @for (trianing of results.training; track trianing) {
          <div
            [routerLink]="'/app/training/details/'+trianing.training_event_time_slot_id">
            <div class="p-3 border rounded clickable-item">
              <h3 class="fs-6 fw-bold text-green mb-2 d-flex align-items-center gap-2 flex-wrap">
                <span [innerHTML]="trianing.training_doctor_partner_name | highlight:searched_string:'capital'"></span>
                <span class="badge text-white"
                [ngStyle]="{'background-color':trianing?.training_status_color_code || ''}">{{trianing?.training_status_name || ''}}</span>
              </h3>
              <div class="row g-2">
                <div class="col-md-6 text-label">
                  <span class="text-muted">Email: </span>
                  <span [innerHTML]="trianing.training_doctor_partner_email | highlight:searched_string"></span>
                </div>
                <div class="col-md-6 text-label"><span class="text-muted">Phone: </span>
                {{trianing.training_doctor_partner_phone? trianing.training_doctor_partner_phone : 'N/A'}}
              </div>
              <!-- <div class="col-md-6 text-label">
              <span class="text-muted">Type of Training: </span>
              <span [innerHTML]="trianing.type_name | highlight:searched_string"></span>
            </div> -->
            <div class="col-md-6 text-label">
              <span class="text-muted">Business Name: </span>
              <span [innerHTML]="(trianing.training_practice_name || 'N/A') | highlight:searched_string"></span>
            </div>
            <div class="col-md-6 text-label">
              <span class="text-muted">Business Email: </span>
              <span [innerHTML]="(trianing.practice_email || 'N/A') | highlight:searched_string"></span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="text-end mt-2">
    <a (click)="viewAllDetails('training')"><small>View All ({{totalRowsOfEach?.training_list}})</small></a>
  </div>
</div>
</div>
}
}

@if ((searchBySalesAgent || isManager) && (show && show.leads) && (filteredUsers && filteredUsers.length)) {
  <div class="col-lg-6 col-sm-12"
    >
    <div class="card card-default h-100 p-3">
      <h3 class="fs-5 fw-bold hex-65-grey mb-3">Leads</h3>
      <div class="d-flex flex-column gap-3">
        @for (user of filteredUsers; track user) {
          <div (click)="navigateToDetails(user)">
            <div class="p-3 border rounded clickable-item">
              <h3 class="fs-6 fw-bold text-green mb-2 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <span [innerHTML]="(user.first_name + ' ' + user.last_name) | highlight:searched_string:'capital'"></span>
                <span class="text-muted fs-6 fw-semibold">ID: {{ user.lead_id }}</span>
              </h3>
              <div class="row g-2">
                <div class="col-md-6 text-label"><span class="text-muted">Email:</span>
                <span [innerHTML]="user.practice_email | highlight:searched_string"></span>
              </div>
              <div class="col-md-6 text-label"><span class="text-muted">Phone:</span>
              {{user.practice_mobile ? user.practice_mobile : 'N/A'}}
            </div>
            <div class="col-md-6 text-label"><span class="text-muted">Business Name:</span>
            <span [innerHTML]="(user.practice_name || 'N/A') | highlight:searched_string"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div style="text-align:right">
  <a (click)="viewAllLeads()"><small>View All ({{resultCount}})</small></a>
</div>
</div>
</div>
}

</div>
</ng-container>


</div>
<ng-template #proposals_listing let-data="data">
  <div class="card card-default h-100 p-3">
    <h3 class="fs-5 fw-bold hex-65-grey mb-3">{{data.heading}}</h3>
    <div class="d-flex flex-column gap-3">
      @for (payment of data.list; track payment) {
        <div [routerLink]="data.link+payment.split_req_id">
          <div class="p-3 border rounded clickable-item">
            <h3 class="fs-6 fw-bold text-green mb-2 d-flex align-items-center gap-2 flex-wrap">
              <span [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
              @if (payment.status==1) {
                <span class="badge bg-warning">Pending</span>
              }
              @if (payment.status==2) {
                <span class="badge bg-success">Success</span>
              }
              @if (payment.status==3) {
                <span class="badge bg-danger">Failed</span>
              }
              @if (payment.status==4) {
                <span class="badge bg-info">Refunded</span>
              }
              @if (payment.status==5) {
                <span class="badge bg-danger">Declined</span>
              }
            </h3>
            <div class="row g-2">
              <div class="col-md-6 text-label"><span class="text-muted">Business Owner Name:</span>
              <span [innerHTML]="payment.doctor_name | highlight:searched_string"></span>
            </div>
            <div class="col-md-6 text-label"><span class="text-muted">Business Owner Email:</span>
            <span [innerHTML]="payment.doctor_email | highlight:searched_string"></span>
          </div>
          <div class="col-md-6 text-label"><span class="text-muted">Customer Email:</span>
        {{payment.patient_email ? (payment.patient_email): 'N/A'}}</div>
        <div class="col-md-6 text-label"><span class="text-muted">Customer Phone:</span>
      {{payment.patient_mobile ? (payment.patient_mobile): 'N/A'}}</div>
    </div>
  </div>
</div>
}
</div>
<div class="text-end mt-2">
  <a (click)="viewAllDetails(data.search_type)"><small>View All ({{data?.count}})</small></a>
</div>
</div>
</ng-template>
<!-- &&(results && results.payments && results.payments.length) -->
<!-- <div class="col-md-6 col-sm-12"
*ngIf="(show && show.training) ">
<div class="card card-default p-2">
  <h3 class="m-0 fs-24 fw-600 hex-65-grey mb-2">Training</h3>
  <div class="p-2 row">
    <p [routerLink]="'/app/training/details/'+478" class="cursor"> go to detail</p>
    <div class="col-md-12 mb-3" *ngFor="let training of results.trainings"
      [routerLink]="'/app/training/details/'+training.478">
      <div class="col-12 py-2 border rounded clickable-item px-2 ">
        <h3 class="my-1 text-green fs-24">
          <span class="h3 text-bold fs-24" [innerHTML]="payment.patient_name | highlight:searched_string:'capital'"></span>
          <span *ngIf="payment.status==1" class="badge bg-warning float-right">Pending</span>
          <span *ngIf="payment.status==2" class="badge bg-success float-right">Success</span>
          <span *ngIf="payment.status==3" class="badge bg-danger float-right">Failed</span>
          <span *ngIf="payment.status==4" class="badge bg-info float-right">Refunded</span>
          <span *ngIf="payment.status==5" class="badge bg-danger float-right">Declined</span>
        </h3>
        <div class="row">
          <div class="col-6 text-label">
            <span class="text-muted">Email:</span>
            <span [innerHTML]="training.patient_email | highlight:searched_string"></span>
          </div>
          <div class="col-6 text-label">
            <span class="text-muted">Phone:</span>
            {{training.patient_mobile ? (training.patient_mobile): 'N/A'}}
          </div>
          <div class="col-12 text-label">
            <span class="text-muted">Payment ID:</span>
            <span *ngIf="training.payment_process_code"
            [innerHTML]="training.payment_process_code | highlight:searched_string"></span>
            <span *ngIf="!training.payment_process_code">N/A</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div> -->
